<template>

    <v-layout wrap>
      <v-flex x12 sm8 offset-sm2 text-center classs="width-vw">
        <Confirm ref="confirmRef" @agree="toVideo"></Confirm>
        <Reanudar v-if="!item.live"
          :watching="watching"
          :btnTitle="btnTitle"
          @openVideo="alertAge('openVideo')"
          @openVideoFromTimestamp="alertAge('openVideoFromTimestamp')"></Reanudar>
        <v-btn block
          color="primary"
          class="btn-live"
          v-if="item.live"
          @click="alertAge()">{{ $t('Ver Live') }}</v-btn>
      </v-flex>
      <!-- <v-flex x12 sm6 class="buttons width-vw">
        <v-btn block outline v-if="!item.inList" @click="addMyList(item)">
          <v-icon>add_circle_outline</v-icon>Añadir a mi lista</v-btn>
        <v-btn block outline m-0 v-if="item.inList" @click="removeMyList(item)">
          <v-icon>remove_circle_outline</v-icon>Eliminar de mi lista</v-btn>
      </v-flex> -->
    </v-layout>
</template>
<script>
import { mapActions } from 'vuex'
import Reanudar from '@/components/Reanudar'
import Confirm from '@/components/Confirm'


export default {
  components: { Reanudar, Confirm },
  props: {
    item: {
      type: Object,
      required: true
    },
    watching: {
      type: Object
    }
  },
  computed: {
    btnTitle () {
      if (this.watching) {
        return this.$t('continue')
      } else return this.$t('Ver Live')
    }
  },
  methods: {
    ...mapActions(['addMyList', 'removeMyList']),
    alertAge(param) {
      if (this.item.rating === 'rating_18') {
        this.$refs.confirmRef.open(param)
      } else {
        this.toVideo(param)

      }
    },
    toVideo(param) {
      if (param) {
        this.$emit(param)
      } else {
        this.$router.push({
          name: 'Live',
          params: { slug: this.item.slug }
        })
      }
    }
  }
}
</script>
<style scoped>
  /deep/ .buttons {
    margin: -4px 0;
  }
  .btn-live {
    margin: 0 10px;
    margin-bottom: 5px;
    padding-top: 0;
  }

  @media (max-width: 600px) {
    .width-vw {
      width: 100vw !important;
    }
  }

</style>
